import { render, staticRenderFns } from "./Contatos.vue?vue&type=template&id=21b6611a&scoped=true&"
import script from "./Contatos.vue?vue&type=script&lang=js&"
export * from "./Contatos.vue?vue&type=script&lang=js&"
import style0 from "./Contatos.vue?vue&type=style&index=0&id=21b6611a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6611a",
  null
  
)

export default component.exports